import React, { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import MainPageTableHeader from "../../layout/body/MainPageTableHeader";
import MainPageHOC from "../../layout/hoc/MainPageHOC";

import { PaginationComponent } from "../../components/Component";
import FetcherComponent from "../../components/shared/FetcherComponent";
import MainPageHeader from "../../components/shared/MainPageHeader";
import PartnersPageTableBody from "../../components/partnerPage/PartnersPageTableBody";

import partnerService from "../../services/partnerService";
import { usePartnerPageContext } from "../../hooks/usePartnerPageContext";

const PartnersPage = () => {
  const {
    setPartners,
    currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
    totalRecords,
    setTotalRecords,
    setPageSize,
    pageSize,
  } = usePartnerPageContext();

  const [searchParams] = useSearchParams();
  const currentPageQueryString = searchParams.get("current-page");
  const pageSizeQueryString = searchParams.get("page-size");

  const fetchPartners = useCallback(
    async () =>
      await partnerService.getPartners({
        currentPage: currentPageQueryString,
        pageSize: pageSizeQueryString,
      }),
    [currentPageQueryString, pageSizeQueryString]
  );

  const handleOnLoadFetchedPartners = useCallback(
    (res) => {
      setPartners(res?.data);
      setCurrentPage(res?.currentPage);
      setTotalPages(res?.totalPages);
      setTotalRecords(res?.totalRecords);
      setPageSize(res?.pageSize);
    },
    [setPartners, setCurrentPage, setTotalPages, setTotalRecords, setPageSize]
  );

  return (
    <MainPageHOC
      headerTitle={"Partners"}
      pageHeader={
        <MainPageHeader
          totalRecords={totalRecords}
          pageName="Partners"
          redirectTo={"create"}
          showAddButton={true}
        />
      }
      tableHeader={
        <MainPageTableHeader pageSize={pageSize} setPageSize={setPageSize} />
      }
      tableBody={
        <FetcherComponent
          key={[currentPageQueryString, pageSizeQueryString]
            .filter(Boolean)
            .join("-")}
          action={fetchPartners}
          onLoad={handleOnLoadFetchedPartners}
        >
          <>
            <PartnersPageTableBody />

            <PaginationComponent
              currentPageNumber={currentPage}
              totalPages={totalPages}
              totalRecords={totalRecords}
              status={pageSizeQueryString}
            />
          </>
        </FetcherComponent>
      }
    />
  );
};

export default PartnersPage;
